import {
  Bird,
  Bug,
  Cat,
  Dog,
  Fish,
  Origami,
  PawPrint,
  Rabbit,
  Rat,
  Snail,
  Squirrel,
  Turtle,
  Worm,
} from 'lucide-react';

export const animalIcons = [
  <Bird key='bird' className='text-(--secondary-color)' />,
  <Bug key='bug' className='text-(--secondary-color)' />,
  <Cat key='cat' className='text-(--secondary-color)' />,
  <Dog key='dog' className='text-(--secondary-color)' />,
  <Fish key='fish' className='text-(--secondary-color)' />,
  <Origami key='origami' className='text-(--secondary-color)' />,
  <PawPrint key='paw-print' className='text-(--secondary-color)' />,
  <Rabbit key='rabbit' className='text-(--secondary-color)' />,
  <Rat key='rat' className='text-(--secondary-color)' />,
  <Snail key='snail' className='text-(--secondary-color)' />,
  <Squirrel key='squirrel' className='text-(--secondary-color)' />,
  <Turtle key='turtle' className='text-(--secondary-color)' />,
  <Worm key='worm' className='text-(--secondary-color)' />,
];

export const animalIconsLength = animalIcons.length;
